import React, { useEffect, useState } from "react";
import StationList from "./StationList";
import StationDetails from "./StationDetails";
import axios from "axios";
import SectionData from "./SectionData";
const StationsMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_STATION_MAPPING;

  const [activePage, setActivePage] = useState("Station");
  const [act, setAct] = useState("StationData");
  const [sec, setSec] = useState("JBP-ET");
  const [activeStation, setActiveStation] = useState("JBP");

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}station-details?station_code=${activeStation}`,
      );
      if (response.statusText === "OK") {
        setData(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeStation]);
  return (
    <div>
      <div className="d-flex justify-content-center my-3">
        <div
          className="position-relative d-flex rounded-pill border"
          style={{
            width: "240px",
            height: "42px",
            background: "#e9ecef",
            cursor: "pointer",
          }}
        >
          <div
            className="position-absolute top-0 start-0 h-100 rounded-pill card-header-soft"
            style={{
              width: "50%",
              transition: "transform 0.3s ease",
              transform:
                act === "StationData" ? "translateX(100%)" : "translateX(0)",
            }}
          />

          <div
            className={`w-50 d-flex align-items-center justify-content-center fw-semibold position-relative ${
              act === "SectionData" ? "text-white" : "text-dark"
            }`}
            onClick={() => setAct("SectionData")}
          >
            Section
          </div>

          <div
            className={`w-50 d-flex align-items-center justify-content-center fw-semibold position-relative ${
              act === "StationData" ? "text-white" : "text-dark"
            }`}
            onClick={() => setAct("StationData")}
          >
            Station
          </div>
        </div>
      </div>

      <div className="row " style={{ height: "80vh" }}>
        <div className="col-md-2 rounded" style={{ height: "60vh" }}>
          <StationList
            activeStation={activeStation}
            setActiveStation={setActiveStation}
            sec={sec}
            setSec={setSec}
          />
        </div>
        {act === "SectionData" && (
          <div className="col-md-10 rounded" style={{ height: "80vh" }}>
            <SectionData sec={sec} setSec={setSec} />
          </div>
        )}
        {act === "StationData" && (
          <div className="col-md-10 rounded" style={{ height: "80vh" }}>
            <StationDetails
              data={data}
              sec={sec}
              activeStation={activeStation}
              setActiveStation={setActiveStation}
            />
          </div>
        )}
      </div>
      {/* <div>
        <SectionData sec={sec} setSec={setSec} />
      </div> */}
    </div>
  );
};
export default StationsMaster;
